export default {
  // Button text
  addButton: 'Add',
  editButton: 'Edit',
  deleteButton: 'Delete',
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',

  // Table column titles
  dictNameColumn: 'Dictionary Name',
  dictIdColumn: 'Dictionary ID',
  orderColumn: 'Order',
  statusColumn: 'Status',
  actionColumn: 'Action',

  // Status
  statusNormal: 'Normal',

  // Form labels
  parentDictLabel: 'Parent Dictionary',
  dictNameLabel: 'Dictionary Name',
  orderLabel: 'Display Order',

  // Form placeholders
  parentDictPlaceholder: 'Please select parent dictionary',
  orderPlaceholder: 'Enter sort order',

  // Validation messages
  dictNameRequired: 'Please enter dictionary name',
  dictIdRequired: 'Please enter dictionary ID',

  // Modal titles
  addTitle: 'Add Dictionary',
  editTitle: 'Edit Dictionary',

  // Success messages
  addSuccess: 'Added successfully',
  editSuccess: 'Modified successfully',
  deleteSuccess: 'Deleted successfully',

  // Tree selection
  mainCategory: 'Main Category',
}
